module.exports = __webpack_public_path__ + "static/media/introduce.cc533a4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程锋锐F3E厢式车/introduce.png
// module id = 698
// module chunks = 0